import { render, staticRenderFns } from "./catalogue.vue?vue&type=template&id=a0809aaa&scoped=true&"
import script from "./catalogue.vue?vue&type=script&lang=js&"
export * from "./catalogue.vue?vue&type=script&lang=js&"
import style0 from "./catalogue.vue?vue&type=style&index=0&id=a0809aaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0809aaa",
  null
  
)

export default component.exports